

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { DelayLoading, MinLoadingTime } from '@/utlitities/delay-loading';
import StLoaderIcon from '@/components/basic/StLoaderIcon.vue';

@Component({
  components: {StLoaderIcon},
})
export default class StLoading extends Vue {
  @Prop({ default: true }) absolute!: boolean;
  @Prop({ default: 'opacity-80' }) overlayClass!: string;
  @Prop() centered!: boolean;
  @Prop() loading!: boolean;
  @Prop() delayLoading!: boolean;

  minLoadingTime = new MinLoadingTime();
  delayLoadingTime = new DelayLoading();

  get minLoading() {
    this.minLoadingTime.val = this.loading;
    return this.minLoadingTime.val;
  }

  get delayLoadingFlag() {
    this.delayLoadingTime.val = this.delayLoading;
    return this.delayLoadingTime.val;
  }
}
